import { useEffect, useState } from 'react';
import { useHistory } from 'react-router';

/**
 * A react-router backport of the latest react-router `useLocation` hook.
 */
export const useLocation = () => {
  const history = useHistory();
  const [location, setLocation] = useState(history.location);

  useEffect(() => {
    const unlisten = history.listen((location) => {
      setLocation(location);
    });
    return () => {
      unlisten();
    };
  }, [history]);
  return location;
};
